import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { Engine, Scene } from "@babylonjs/core";
import { RENDERQUALITYFACTOR } from "../redux_store/appState";

const useStyles = makeStyles({
    root: {},
});

export default function HeaderBar(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const reactCanvasBracket = useRef(null);

    const {
        antialias,
        engineOptions,
        adaptToDeviceRatio,
        sceneOptions,
        onRender,
        onSceneReady,
        onLoadModel,
        threeDMode,
        modelFileName,
        backgroundMode,
        toggleEnvironment,
        changeMeshGroupColour,
        updateColours,
        ...rest
    } = props;

    const [loaded, setLoaded] = useState(false);
    const [scene, setScene] = useState(null);
    const renderQuality = useSelector((state) => state.app?.designer?.designer3D?.[RENDERQUALITYFACTOR]);
    if (!renderQuality) renderQuality = 1;
    let renderFactor = (0.2 / renderQuality) * 3 + 0.7;

    useEffect(() => {
        if (!loaded && reactCanvasBracket?.current) {
            // window.devicePixelRatio
            setLoaded(true);

            // reactCanvasBracket.current.style.width = "2400px";
            // reactCanvasBracket.current.style.height = "2400px";

            const engine = new Engine(reactCanvasBracket?.current, antialias, engineOptions, adaptToDeviceRatio);

            // reactCanvasBracket.current.style.width = "100%";
            // reactCanvasBracket.current.style.height = "100%";

            const scene = new Scene(engine, sceneOptions);
            scene.getEngine().setHardwareScalingLevel(renderFactor * window.devicePixelRatio);
            setScene(scene);
            if (scene.isReady()) {
                props.onSceneReady(scene, props.job);
            } else {
                scene.onReadyObservable.addOnce((scene) => props.onSceneReady(scene, props.job));
            }

            engine.runRenderLoop(() => {
                if (typeof onRender === "function") {
                    onRender(scene, dispatch);
                }
                scene.render();
            });

            document.onvisibilitychange = function () {
                console.log("Visibility of page has changed!");
                if (scene) {
                    if (document.hidden) {
                        scene.getEngine().stopRenderLoop();
                    } else {
                        console.log("bbylon started");
                        scene.getEngine().runRenderLoop(() => {
                            if (typeof onRender === "function") {
                                onRender(scene, dispatch);
                            }
                            scene.render();
                        });
                    }
                }
            };
        }

        return () => {
            if (scene !== null) {
                scene.dispose();
            }
        };
    }, [reactCanvasBracket]);

    return (
        <canvas
            style={
                props.style
                    ? props.style
                    : {
                          zIndex: 0,
                          display: "block",
                          position: "absolute",
                          top: "0px",
                          right: "0px",
                          left: "0px",
                          backgroundColor: "rgba(255, 255, 255, 255)",
                          width: "100%",
                          height: "100%",
                          // height: "600px",
                          color: "#000",
                          // transition: "visibility 0.3s, opacity 0.3s linear",
                      }
            }
            ref={reactCanvasBracket}
            // {...rest}
        />
    );
}
